import { getMaxDecimalPlaces } from "utils/getMaxDecimalPlaces";

import { LegendItemModel } from "models/LegendItem";

import type { IpdbBin } from "../contexts/ipdbStore";

interface BinColorPair {
  value: number;
  color: string;
}

interface BuildLegendItemsParams {
  binColorPairs: BinColorPair[];
  ipdbBin: IpdbBin;
  min: number;
  max: number;
  binSize: number;
  numOfColors: number;
}

export function buildLegendItems({
  binColorPairs,
  ipdbBin,
  min,
  max,
  binSize,
  numOfColors
}: BuildLegendItemsParams): LegendItemModel[] {
  const decimalPlaces = getMaxDecimalPlaces([min, max, binSize]);
  const legendItems: LegendItemModel[] = [];

  binColorPairs.forEach((pair, idx) => {
    const li = new LegendItemModel(pair.value.toFixed(1));
    li.text = "";
    const binValue = pair.value > max ? max : pair.value;
    const binValueStr = binValue.toFixed(decimalPlaces);

    if (idx === 0) {
      if (ipdbBin.lessThan === "" || isNaN(Number(ipdbBin.lessThan))) {
        li.text = `${min.toFixed(decimalPlaces)} - ${binValueStr}`;
      } else {
        li.text = "< " + binValueStr;
      }
    } else if (
      idx === numOfColors - 1 &&
      !isNaN(Number(ipdbBin.greaterThan)) &&
      ipdbBin.greaterThan !== ""
    ) {
      li.text = "≥ " + binValueStr;
    } else {
      const previousBinValueStr = binColorPairs[idx - 1].value.toFixed(decimalPlaces);
      li.text = `${previousBinValueStr} - ${binValueStr}`;
    }

    li.title = li.text;
    li.value = binValueStr;
    li.color = pair.color;
    legendItems.push(li);
  });

  return legendItems;
}
